module.exports = __webpack_public_path__ + "static/img/App item.d54348a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls39/App item.png
// module id = ogop
// module chunks = 12